import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ProductionToolBomItemService extends Service {
	constructor(injector: Injector) {
		super("ProductionToolBomItem", injector);
	}

	// API
	forProductionToolId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForProductionToolId/${id}`);
	}
}
